import { Box, Text, Link, HStack } from '@primerai/thread';
import { Link as RouterLink } from 'wouter';
import { FooterContent } from './Public.styles';
import { TERMS_URL, PRIVACY_POLICY_URL, TEXT_SIZE } from '~/constants';
import { LOGIN, ROOT } from '~/routes/paths';
import { getLocation } from '~/utils/window';

const LoginPrompt = () => {
  const { search, hash } = getLocation();
  // Don't carry a reset_token into the sign-in link. It now rides in the hash
  // (not search), but guard both so the token never propagates regardless of
  // whether the page has scrubbed the fragment yet.
  const hasResetToken =
    search.includes('reset_token') || hash.includes('reset_token');
  const href = hasResetToken ? LOGIN : `${LOGIN}${search}`;
  return (
    <Box>
      <Text mr="$3" size={TEXT_SIZE.DEFAULT}>
        Already have an account?
      </Text>
      <Link as={RouterLink} to={href}>
        Sign in
      </Link>
    </Box>
  );
};

export const LegalLinks = () => (
  <Box display="flex">
    <Link href={TERMS_URL} isExternal>
      Terms
    </Link>

    <Box borderLeft="$default" mx="$4" />
    <Link href={PRIVACY_POLICY_URL} isExternal>
      Privacy
    </Link>
  </Box>
);

const PublicFooter = () => {
  const { pathname } = getLocation();

  switch (pathname) {
    case LOGIN:
    case ROOT:
      return (
        <FooterContent>
          <HStack justifyContent="center">
            <LegalLinks />
          </HStack>
        </FooterContent>
      );
    default:
      return (
        <FooterContent>
          <HStack justifyContent="center">
            <LegalLinks />
            <Box borderLeft="$default" mx="$4" />
            <LoginPrompt />
          </HStack>
        </FooterContent>
      );
  }
};

export default PublicFooter;
